(() => {
  'use strict';
  let revision = 0;
  const refresh = async () => {
    const own = ++revision;
    const links = Array.from(document.querySelectorAll('[data-header-continue]'));
    const runtime = window.DIMRuntime;
    const staff = runtime?.verified && window.DIMStorefrontDisplay?.focusedContext(runtime) && runtime.display;
    const visibleContext = document.querySelector('.dim-header')?.dataset.dimStorefrontResolved !== 'false' || Boolean(staff);
    if (staff) {
      document.querySelectorAll('[data-dim-store-name]').forEach(node => { node.textContent = staff.displayName; node.hidden = false; });
      const single = window.DIMStorefrontDisplay?.singleSelection(staff);
      document.querySelectorAll('[data-dim-header-route]').forEach(node => {
        const route = node.dataset.dimHeaderRoute;
        if (route === 'product' && single) { node.hidden = true; return; }
        const target = new URL(node.dataset.dimHeaderDestination, window.location.origin);
        if (target.origin !== window.location.origin) return;
        if (single && ['upload', 'create'].includes(route)) {
          target.searchParams.set('product', single.productId); target.searchParams.set('variant', single.variantId);
        }
        if (node.tagName === 'A') { node.href = `${target.pathname}${target.search}`; return; }
        const link = document.createElement('a');
        link.className = node.className; link.href = `${target.pathname}${target.search}`;
        link.dataset.journeyEntry = node.dataset.dimHeaderEntry;
        link.setAttribute('data-journey-explicit', ''); link.setAttribute('data-dim-journey-transition', '');
        while (node.firstChild) link.appendChild(node.firstChild);
        node.replaceWith(link);
      });
    }
    let continuation = null;
    try { if (visibleContext) continuation = await window.DIMSourceIntake?.describeContinuation?.(); } catch (_) { /* no false promise */ }
    if (own !== revision) return;
    links.forEach(link => {
      link.hidden = !continuation;
      if (continuation) link.setAttribute('href', window.DreamItJourneyRoutes.continuationUrl());
      else link.removeAttribute('href');
      // This is intentionally neutral: current saved wording is never a label.
      const description = link.querySelector('[data-header-continue-description]');
      if (description) description.textContent = link.dataset.continueDescription || 'Your design in progress';
    });
  };
  const initialise = () => { void refresh(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('click', event => { if (event.target.closest?.('.dim-header')) void refresh(); }, true);
  document.addEventListener('toggle', event => { if (event.target.closest?.('.dim-header')) void refresh(); }, true);
  document.addEventListener('shopify:section:load', initialise);
  document.addEventListener('dim:runtime-authenticated', initialise);
  document.addEventListener('dim:runtime-verified', initialise);
  window.addEventListener('pageshow', initialise);
  window.addEventListener('focus', initialise);
})();
